//* Components Imports
import CondicoesEspeciaisBox from "./CondicoesEspeciaisBox";

//* Variables Imports
import { URL } from "../../../variables";

function DadosExamePanel({ inscricao, renderCampo, formatLingua, formatNivel, getExamesAnteriores }) {
  return (
    <>
      <h5 style={{ color: "black", marginTop: 10, marginBottom: 10 }}>
        Preferências do Exame
      </h5>
      {renderCampo("Língua Estrangeira", formatLingua(inscricao.linguaEstrangeira))}
      {renderCampo("Nível de Ensino", formatNivel(inscricao.nivelEnsino))}
      <div style={{ marginBottom: 10 }}>
        <b style={{ color: "black" }}>Áreas de Conhecimento: </b>
        <div style={{ marginTop: 6 }}>
          {(inscricao.areasConhecimento || []).length > 0 ? (
            <div className="flex flex-wrap" style={{ gap: 6 }}>
              {(inscricao.areasConhecimento || []).map((area, idx) => (
                <span
                  key={idx}
                  style={{
                    background: "#ececf1",
                    borderRadius: 16,
                    padding: "4px 10px",
                  }}
                >
                  {area}
                </span>
              ))}
            </div>
          ) : (
            <span>-</span>
          )}
        </div>
      </div>

      <CondicoesEspeciaisBox inscricao={inscricao} />

      {getExamesAnteriores(inscricao).length > 0 && (
        <div style={{ marginTop: 20 }}>
          <h5 style={{ color: "black", marginBottom: 10 }}>Exames Anteriores</h5>
          <div className="table-rep-plugin">
            <div className="table-responsive mb-0" data-pattern="priority-columns">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Ano(s)</th>
                    <th>Arquivo</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {getExamesAnteriores(inscricao).map((ex, idx) => (
                    <tr key={`ex-anterior-${idx}`}>
                      <td>{ex.nome || "-"}</td>
                      <td>{ex.anos || "-"}</td>
                      <td>{ex.nomeOriginal || "-"}</td>
                      <td>
                        {ex.caminho ? (
                          <a
                            href={`${ex.caminho}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-sm btn-primary"
                            style={{ color: "white" }}
                          >
                            Ver Documento
                          </a>
                        ) : (
                          <span>-</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DadosExamePanel;